import classNames from 'classnames';
import { Outlet } from 'react-router-dom';

import usePlatform from '@/hooks/use-platform';
import { layoutClassNames } from '@/utils/consts';
import IntroSwiper from '@/components/IntroSwiper';

import CustomContent from './CustomContent';
import styles from './index.module.scss';
import BrandingHeader from '@/components/BrandingHeader';
import { useContext } from 'react';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import { getBrandingLogoUrl } from '@/utils/logo';

const AppLayout = () => {
  const { isMobile } = usePlatform();
  const { experienceSettings, theme } = useContext(PageContext);

  const isDarkModeEnabled = experienceSettings?.color?.isDarkModeEnabled ?? false;
  const branding = experienceSettings?.branding;
  const logo = branding ? getBrandingLogoUrl({ theme, branding, isDarkModeEnabled }) : null;

  return (
    <>
      {experienceSettings && (
        <BrandingHeader
          className={classNames(styles.header, layoutClassNames.brandingHeader)}
          logo={logo}
        />
      )}
      <div className={styles.viewBox}>
        <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
          <IntroSwiper />
          {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
          <div className={styles.rightContainer}>
            <main className={classNames(styles.main, layoutClassNames.mainContent)}>
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppLayout;
